import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import api from '../services/axios';
import alertService from '../services/alerts';
import '../styles/AlumnosPage.css';
import '../styles/ExportModal.css';   
import { AuthContext } from '../context/AuthContext';  

function AlumnosPage() {
  const [idFilter, setIdFilter] = useState('');
  const [filteredAlumnos, setFilteredAlumnos] = useState([]);
  const [error, setError] = useState('');

  const [courses, setCourses] = useState([]);
  const [cursoInteres, setCursoInteres] = useState('');

  const [searchQuery, setSearchQuery] = useState('');
  const [nombre, setNombre] = useState('');
  const [apellidoPaterno, setApellidoPaterno] = useState('');
  const [apellidoMaterno, setApellidoMaterno] = useState('');

  const [idProspecto, setIdProspecto] = useState('');
  const [fechaInscripcionMin, setFechaInscripcionMin] = useState('');
  const [fechaInscripcionMax, setFechaInscripcionMax] = useState('');
  const [numeroMatricula, setNumeroMatricula] = useState('');
  const [estadoActividad, setEstadoActividad] = useState('');
  const [razonBaja, setRazonBaja] = useState('');
  const [observaciones, setObservaciones] = useState('');

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const navigate = useNavigate();
  const filtersPanelRef = useRef(null);
  const overlayRef = useRef(null);

  const [searchTrigger, setSearchTrigger] = useState(0);
  
  const location = useLocation(); 


  
   const [sidebarOpen, setSidebarOpen] = useState(false);
   const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);
 
   useEffect(() => {
     const handleResize = () => {
       const mobile = window.innerWidth < 1025;
       setIsMobile(mobile);
       if (!mobile) {
         setSidebarOpen(true);
       } else {
         setSidebarOpen(false);
       }
     };
     window.addEventListener('resize', handleResize);
    
     
     if (window.innerWidth >= 1025) {
       setSidebarOpen(true);
     }
     return () => window.removeEventListener('resize', handleResize);
   }, []);
   
   useEffect(() => {
     if (isMobile) {
       setSidebarOpen(false);
     }
   }, [location, isMobile]);
   const toggleSidebar = () => {
     setSidebarOpen((prev) => !prev);
   };
 
   const handleCloseSidebar = () => {
     if (isMobile && sidebarOpen) {
       setSidebarOpen(false);
     }
   };
 

  const areFiltersDefault = () => {
    return (
      searchQuery.trim() === '' &&
      idProspecto.trim() === '' &&
      fechaInscripcionMin === '' &&
      fechaInscripcionMax === '' &&
      cursoInteres.trim() === '' &&
      estadoActividad.trim() === '' &&
      numeroMatricula.trim() === '' &&
      razonBaja.trim() === '' &&
      observaciones.trim() === ''
    );
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const alumnosToShow =
    areFiltersDefault()
      ? filteredAlumnos.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
      : filteredAlumnos;

  const nextPage = () => {
    if (currentPage * itemsPerPage < filteredAlumnos.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };


  const fetchCursos = async () => {
    try {
      const response = await api.get('/cursos');
      setCourses(response.data);
    } catch (err) {
    }
  };

  useEffect(() => {
    fetchAlumnos();
    fetchCursos();
  }, []);

  function formatDate(dateString) {
    if (!dateString) return '';
    return dateString.split('T')[0]; 
  }

  const fetchAlumnos = async () => {
    try {
      // Si hay filtros aplicados, usar la ruta de filtros
      if (!areFiltersDefault()) {
        const response = await api.get('/filtros/alumnos', {
          params: {
            id_prospecto: idProspecto,
            fecha_inscripcion_min: fechaInscripcionMin,
            fecha_inscripcion_max: fechaInscripcionMax,
            curso_actual: cursoInteres,
            estado_actividad: estadoActividad,
            numero_matricula: numeroMatricula,
            razon_baja: razonBaja,
            observaciones: observaciones,
            search: searchQuery,
          },
        });
        setFilteredAlumnos(response.data);
      } else {
        // Si no hay filtros, obtener todos los alumnos
        const response = await api.get('/alumnos');
        setFilteredAlumnos(response.data);
      }
    } catch (err) {
      console.error('Error al obtener alumnos:', err);
      setError('Error al obtener la lista de alumnos');
    }
  };
  
  const fetchAlumnoById = async (id) => {
    try {
      const response = await api.get(`/alumnos/${id}`);
      setFilteredAlumnos([response.data]);
    } catch (err) {
      setFilteredAlumnos([]);
    }
  };
  
  useEffect(() => {
    if (idFilter.trim()) {
      fetchAlumnoById(idFilter.trim());
    } else {
      fetchAlumnos();
    }
  }, [
    searchTrigger,
    searchQuery,
    idProspecto,
    fechaInscripcionMin,
    fechaInscripcionMax,
    cursoInteres,
    estadoActividad,
    numeroMatricula,
    razonBaja,
    observaciones,
    idFilter,
  ]);
  
  useEffect(() => {
    fetchAlumnos();
  }, [searchTrigger]);
  
  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
  };
  
  const handleEdit = (idAlumno) => {
    navigate(`/alumnos/editar/${idAlumno}`);
  };

  const handleDelete = async (idAlumno) => {
    const confirmed = await alertService.confirm(
      'Eliminar Alumno',
      '¿Estás seguro de que quieres eliminar este alumno? Esta acción no se puede deshacer.',
      {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      }
    );
    
    if (!confirmed.isConfirmed) return;
    
    try {
      await api.delete(`/alumnos/${idAlumno}`);
      setFilteredAlumnos(filteredAlumnos.filter((alumno) => alumno.id_alumno !== idAlumno));
      setError('');
      await alertService.success(
        'Alumno Eliminado',
        'El alumno ha sido eliminado exitosamente.'
      );
    } catch (err) {
      let errorMessage = 'Error al eliminar el alumno';
      
      if (err.response && err.response.status === 409) {
        errorMessage = 'No se puede eliminar el alumno porque está siendo utilizado en otra tabla';
      } else if (err.response && err.response.status === 403) {
        errorMessage = 'No tienes permisos para eliminar alumnos';
      }
      
      await alertService.error('Error', errorMessage);
      console.error('Error al eliminar alumno:', err);
    }
  };

  const handleAddAlumno = () => {
    navigate('/alumnos/agregar');
  };

  const handleClosePanel = () => {
    if (!areFiltersDefault()) {
      setFiltersApplied(true);
    }
    setIsFilterOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (overlayRef.current && overlayRef.current.contains(e.target)) {
      handleClosePanel();
    }
  };

  const applyFilters = () => {
    setSearchTrigger((prev) => prev + 1);
    setFiltersApplied(true);
    setCurrentPage(1);
    setIsFilterOpen(false);
  };

  const cancelFilters = () => {
    setIdProspecto('');
    setFechaInscripcionMin('');
    setFechaInscripcionMax('');
    setCursoInteres('');
    setEstadoActividad('');
    setNumeroMatricula('');
    setRazonBaja('');
    setObservaciones('');
    setSearchQuery('');
    setFiltersApplied(false);
    setIsFilterOpen(false);
    setCurrentPage(1);
    setSearchTrigger((prev) => prev + 1);
  };
  
  const openExportModal = () => {
    setIsModalOpen(true);
    // Establecer fechas por defecto (último mes)
    const today = new Date();
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    setStartDate(lastMonth.toISOString().split('T')[0]);
    setEndDate(today.toISOString().split('T')[0]);
  };
  const closeExportModal = () => {
    setIsModalOpen(false);
    setStartDate('');
    setEndDate('');
  };
  const isDateRangeValid = () => {
    if (!startDate || !endDate) return false;
    return new Date(startDate) <= new Date(endDate);
  };

  const handleExport = async (formato) => {
    try {
      // Validar fechas
      if (!startDate || !endDate) {
        await alertService.error('Error', 'Por favor selecciona las fechas de inicio y fin');
        return;
      }
      
      if (new Date(startDate) > new Date(endDate)) {
        await alertService.error('Error', 'La fecha de inicio no puede ser mayor a la fecha de fin');
        return;
      }

      const params = {
        tabla: 'alumnos',
        formato,
        fecha_inicio: startDate,
        fecha_fin: endDate,
      };
      const response = await api.get('/reportes/reporte', {
        params,
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `reporte_alumnos.${formato === 'excel' ? 'xlsx' : 'pdf'}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      closeExportModal();
    } catch (err) {
      let errorMessage = 'Error al exportar el reporte';
      
      if (err.response && err.response.status === 404) {
        errorMessage = err.response.data.message || 'No hay datos para exportar en el período seleccionado';
      } else if (err.response && err.response.status === 500) {
        errorMessage = 'Error interno del servidor al generar el reporte';
      }
      
      await alertService.error('Error', errorMessage);
    }
  };



  
  const { user } = useContext(AuthContext);
  const allowedRolesForActions = ['administrador', 'moderador']; 
  

  return (
    <div className="dashboard-container">
      {(!isMobile || (isMobile && sidebarOpen)) && (
        <Sidebar
          onLogoClick={() => {
            if (isMobile) setSidebarOpen(false);
          }}
          onLinkClick={handleCloseSidebar}
        />
      )}
      <div className={`main-content ${isFilterOpen ? 'panel-open' : ''}`} onClick={handleCloseSidebar}>
        <div className="dashboard-title-card">
          {isMobile && (
            <button 
              className="menu-toggle"
              onClick={toggleSidebar}
              aria-label="Abrir menú"
            >
              <i className="fas fa-bars"></i>
            </button>
          )}
          <div className="dashboard-title-section">
            <h1 className="dashboard-title">Alumnos</h1>
            <span className="dashboard-title-sub">Gestión de alumnos registrados</span>
          </div>
        </div>

        {error && (
          <div className="error-message" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <div className="search-filter-container">
          <input
            type="text"
                            placeholder="Buscar por nombre/apellidos del prospecto, observaciones o razón de baja..."
            value={searchQuery}
            onChange={handleSearch}
            className="search-input"
          />
          <button
            className="filter-button"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
          >
            <i className="fa-solid fa-sliders"></i>Filtros
          </button>
          
        </div>

        {isFilterOpen && (
          <div
            className="filters-overlay"
            ref={overlayRef}
            onClick={handleOverlayClick}
          ></div>
        )}

        {isFilterOpen && (
          <div className="filters-panel" ref={filtersPanelRef}>
            <button className="close-button" onClick={handleClosePanel}>
              ×
            </button>
            <h2>Filtros de Alumnos</h2>
            <div className="filter-group">
              <label>ID Prospecto</label>
              <input
                type="number"
                value={idProspecto}
                onChange={(e) => {
                  setIdProspecto(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                className="filter-input"
                placeholder="Ej. 10"
                min="1"
              />
            </div>
            <div className="filter-group">
              <label>Fecha Inscripción (Mín)</label>
              <input
                type="date"
                value={fechaInscripcionMin}
                onChange={(e) => {
                  setFechaInscripcionMin(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                className="filter-input"
              />
              <label>Fecha Inscripción (Máx)</label>
              <input
                type="date"
                value={fechaInscripcionMax}
                onChange={(e) => {
                  setFechaInscripcionMax(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                className="filter-input"
              />
            </div>
            <div className="filter-group">
              <label>Curso Actual</label>
              <select
                value={cursoInteres}
                onChange={(e) => {
                  setCursoInteres(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                className="filter-input"
              >
                <option value="">Todos</option>
                {courses.map((c) => (
                  <option key={c.id} value={c.nombre_curso}>
                    {c.nombre_curso}
                  </option>
                ))}
              </select>
            </div>
            <div className="filter-group">
              <label>Estado de Actividad</label>
              <select
                value={estadoActividad}
                onChange={(e) => {
                  setEstadoActividad(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                className="filter-input"
              >
                <option value="">Todos</option>
                <option value="activo">Activo</option>
                <option value="baja">Baja</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Número de Matrícula</label>
              <input
                type="text"
                value={numeroMatricula}
                onChange={(e) => {
                  setNumeroMatricula(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                className="filter-input"
              />
            </div>
            <div className="filter-group">
              <label>Observaciones</label>
              <input
                type="text"
                value={observaciones}
                onChange={(e) => {
                  setObservaciones(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                placeholder="Buscar en observaciones..."
                className="filter-input"
              />
            </div>
            <div className="filter-group">
              <label>Razón de Baja</label>
              <select
                value={razonBaja}
                onChange={(e) => {
                  setRazonBaja(e.target.value);
                  setCurrentPage(1);
                  setSearchTrigger((prev) => prev + 1);
                }}
                className="filter-input"
              >
                <option value="">Todas</option>
                <option value="Problemas económicos">Problemas económicos</option>
                <option value="Problemas de horario">Problemas de horario</option>
                <option value="Problemas familiares">Problemas familiares</option>
                <option value="Razones personales">Razones personales</option>
                <option value="Problemas de conexión">Problemas de conexión</option>
                <option value="Falta de adaptación en línea">Falta de adaptación en línea</option>
                <option value="Inconforme con el curso">Inconforme con el curso</option>
                <option value="Bajo rendimiento">Bajo rendimiento</option>
                <option value="Diferencias con el docente">Diferencias con el docente</option>
              </select>
            </div>
            <button className="apply-filters-button" onClick={applyFilters}>
              Aplicar Filtros
            </button>
          </div>
        )}

        <div className="add-button-container">
          {allowedRolesForActions.includes(user?.rol) && (
            <button className="add-button" onClick={handleAddAlumno}>
              <i className="fas fa-plus"></i>
              Agregar Alumno
            </button>
          )}
          <button className="export-button" onClick={openExportModal}>
            <i className="fas fa-download"></i>
            Exportar
          </button>
          {filtersApplied && (
            <button className="cancel-filters-button" onClick={cancelFilters}>
              <i className="fas fa-times"></i>
              Cancelar Filtros
            </button>
          )}
        </div>

          <div className="alumnos-grid">
            {alumnosToShow.length > 0 ? (
              alumnosToShow.map((al) => (
                <div key={al.id_alumno} className="alumno-card">
                  <div className="card-header">
                    <div className="alumno-id">
                      <span className="id-label">ID</span>
                      <span className="id-value">{al.id_alumno}</span>
                    </div>
                    <div className="alumno-name">
                      <span className="name-text">
                        {al.nombre_completo ? al.nombre_completo : `Alumno #${al.id_alumno}`}
                      </span>
                    </div>
                    {allowedRolesForActions.includes(user?.rol) && (
                      <div className="card-actions">
                        <button
                          className="action-btn edit-btn"
                          onClick={() => handleEdit(al.id_alumno)}
                          title="Editar alumno"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="action-btn delete-btn"
                          onClick={() => handleDelete(al.id_alumno)}
                          title="Eliminar alumno"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    )}
                  </div>
                  
                  <div className="card-content">
                    <div className="info-section">
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-user"></i> Nombre
                        </span>
                        <span className="info-value">{al.nombre_completo || 'No asignado'}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-user"></i> ID Prospecto
                        </span>
                        <span className="info-value">{al.id_prospecto || 'No asignado'}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-graduation-cap"></i> Curso Actual
                        </span>
                        <span className="info-value">{al.curso_actual}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-calendar"></i> Fecha Inscripción
                        </span>
                        <span className="info-value">{formatDate(al.fecha_inscripcion)}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-id-card"></i> Matrícula
                        </span>
                        <span className="info-value">{al.numero_matricula || 'No asignada'}</span>
                      </div>
                      {al.numero_telefonico && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-phone"></i> Teléfono
                          </span>
                          <span className="info-value">{al.numero_telefonico}</span>
                        </div>
                      )}
                      {al.tipo_red_social && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-share-alt"></i> Red Social
                          </span>
                          <span className="info-value">{al.tipo_red_social}</span>
                        </div>
                      )}
                      {al.observaciones && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-sticky-note"></i> Observaciones
                          </span>
                          <span className="info-value">{al.observaciones}</span>
                        </div>
                      )}
                      {al.razon_baja && (
                        <div className="info-item">
                          <span className="info-label">
                            <i className="fas fa-times-circle"></i> Razón de Baja
                          </span>
                          <span className="info-value">{al.razon_baja}</span>
                        </div>
                      )}
                    </div>
                    
                    <div className="status-section">
                      <div className="estado-container">
                        <span className="estado-label">Estado de Actividad:</span>
                        <span className={`estado-badge ${al.estado_actividad === 'activo' ? 'estado-activo' : 'estado-inactivo'}`}>
                          {al.estado_actividad}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <div className="empty-icon">
                  <i className="fas fa-graduation-cap"></i>
                </div>
                <h3>No hay alumnos para mostrar</h3>
                <p>No se encontraron alumnos con los filtros aplicados</p>
              </div>
            )}
          </div>



        {isModalOpen && (
          <div className="export-modal-overlay">
            <div className="export-modal">
              <h3>Exportar Reporte de Alumnos</h3>
              
              <div className="export-filters">
                <div className="filter-group">
                  <label>Fecha de Inicio:</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="filter-input"
                  />
                </div>
                
                <div className="filter-group">
                  <label>Fecha de Fin:</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="filter-input"
                  />
                </div>
              </div>
              
              {!isDateRangeValid() && (
                <p style={{ color: 'red', marginBottom: '1rem' }}>
                  Selecciona una fecha inicial y final válidas.
                </p>
              )}
              
              <div className="export-buttons">
                <button 
                  onClick={() => handleExport('excel')} 
                  disabled={!isDateRangeValid()}
                  className="export-btn excel"
                >
                  <i className="fas fa-file-excel"></i>
                  Exportar a Excel
                </button>
                <button 
                  onClick={() => handleExport('pdf')} 
                  disabled={!isDateRangeValid()}
                  className="export-btn pdf"
                >
                  <i className="fas fa-file-pdf"></i>
                  Exportar a PDF
                </button>
              </div>
              
              <button onClick={closeExportModal} className="close-modal">
                <i className="fas fa-times"></i>
                Cancelar
              </button>
            </div>
          </div>
        )}

        {areFiltersDefault() && (
          <div className="pagination-container">
            {currentPage > 1 && (
              <button onClick={prevPage}>
                <i className="fas fa-chevron-left"></i>
                Anterior
              </button>
            )}
            <span>
              Página {currentPage} de {Math.ceil(filteredAlumnos.length / itemsPerPage)}
            </span>
            {currentPage * itemsPerPage < filteredAlumnos.length && (
              <button onClick={nextPage}>
                Siguiente
                <i className="fas fa-chevron-right"></i>
              </button>
            )}
          </div>
        )}
      </div>
      {isMobile && sidebarOpen && (
        <div className="overlay" onClick={handleCloseSidebar}></div>
      )}
    </div>
  );
}

export default AlumnosPage;
